var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 21.844L2.9119 11.844C2.06923 11.002 1.51306 9.91606 1.32226 8.7402C1.13146 7.56434 1.31571 6.35826 1.8489 5.293V5.293C2.25095 4.48912 2.83827 3.79228 3.56244 3.25989C4.28662 2.7275 5.12694 2.3748 6.01415 2.23085C6.90137 2.08691 7.81009 2.15583 8.66544 2.43195C9.5208 2.70807 10.2983 3.18347 10.9339 3.819L12.4999 5.384L14.0659 3.819C14.7015 3.18347 15.479 2.70807 16.3343 2.43195C17.1897 2.15583 18.0984 2.08691 18.9856 2.23085C19.8729 2.3748 20.7132 2.7275 21.4374 3.25989C22.1615 3.79228 22.7488 4.48912 23.1509 5.293C23.6834 6.35784 23.8673 7.56321 23.6767 8.7384C23.4861 9.91359 22.9306 10.999 22.0889 11.841L12.4999 21.844Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgHeart;